import { app } from '../../../../../../app';
import { Controller } from './copy-users-to-labels.controller';

app.component('companyUserLabelMembersCopy', {
    bindings: {
        users: '<',
        companyId: '<',
        labels: '<',
		userLabelId:'<'
    },
    controller: Controller,
    templateUrl: require('./copy-users-to-labels.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/copy/copy-users-to-labels.component.js